/* eslint-disable */

/** unique or primary key constraints on table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaConstraint {
  /** unique or primary key constraint on columns "udf_column_id", "context_id" */
  MaterialUdfSchemaEnforceUnique = 'material_udf_schema_enforce_unique',
  /** unique or primary key constraint on columns "material_udf_schema_id" */
  MaterialUdfSchemaPkey = 'material_udf_schema_pkey'
}

/** select columns of table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UdfColumnType = 'udf_column_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_udf_schema_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaSelectColumnArgoMaterialUdfSchemaAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_udf_schema_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaSelectColumnArgoMaterialUdfSchemaAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UdfColumnType = 'udf_column_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

